import { buildB2bCopilotDevPlanArtifact, isB2bCopilotDevPlanArtifact } from '@/features/chat/demo/resolveB2bArtifactPreview.js'
import { buildSyntheticDataDemoArtifact, isSyntheticDataDemoArtifact } from '@/features/chat/demo/resolveSyntheticDataArtifactPreview.js'
import { buildWebsiteCrmDocArtifact, buildWebsiteCrmHtmlArtifact, isWebsiteCrmDocArtifact, isWebsiteCrmHtmlArtifact } from '@/features/chat/demo/resolveWebsiteCrmArtifactPreview.js'
import { buildZohoCrmIntegrationArtifact, isZohoCrmIntegrationArtifact } from '@/features/chat/demo/resolveZohoArtifactPreview.js'

const DEMO_RESOLVERS = [
  [isWebsiteCrmHtmlArtifact, buildWebsiteCrmHtmlArtifact],
  [isWebsiteCrmDocArtifact, buildWebsiteCrmDocArtifact],
  [isZohoCrmIntegrationArtifact, buildZohoCrmIntegrationArtifact],
  [isB2bCopilotDevPlanArtifact, buildB2bCopilotDevPlanArtifact],
  [isSyntheticDataDemoArtifact, buildSyntheticDataDemoArtifact],
]

export function resolveDemoArtifact(artifactId, selection) {
  const match = DEMO_RESOLVERS.find(([isMatch]) => isMatch(selection))
  return match ? match[1](artifactId, selection) : null
}
